module.exports = __webpack_public_path__ + "assets/img/open-access-government.f9a82cb9.png";